import 'shared/trackjs'
import { createRoot } from 'react-dom/client'
import App from './components/app'

global.Giphy.renderSearch = (el, data) => {
    const root = createRoot(el)

    root.render(<App {...data} />, el)
    if (module.hot) {
        module.hot.accept('./components/app', () => {
            const NextApp = require('./components/app').default
            root.render(<NextApp {...data} />)
        })
    }
}
